<div class="loading-cont">
    <awc-icon [icon]="spinner" [size]="size"></awc-icon>
</div>